module.exports = dependencies['@sitebase/ui-kit']['3.23.6']['module'];